import * as Sentry from '@sentry/react'

import { useStore } from '../store'

export const sentry = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE,
  // Session Replay
  replaysSessionSampleRate: import.meta.env.VITE_SENTRY_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLACE_ON_ERROR_SAMPLE_RATE,
  environment: import.meta.env.VITE_ENV,
  beforeSend(event: Sentry.ErrorEvent): Sentry.ErrorEvent {
    const email = useStore.getState().email
    const userId = useStore.getState().userId
    if (!event.user) {
      event.user = {
        email,
        id: userId,
      }
    }
    return event
  },
}
